import React from 'react';
import Row from 'components/Row';
import Col from 'components/Col';
import LayoutDatePicker from 'components/forms/layoutDatePicker';
import ReportDropDown from 'ui/page/reports/components/reportDropDown';
import moment from 'moment';
import {reportDateFormat} from 'helpers/constants';
import {compose} from 'helpers/objects';

const filterOptions = {
  branch: -1,
  branchOptions: [
    {
      value: -1,
      label: 'All Stores',
    },
  ],
  poolType: -1,
  poolTypeOptions: [ ],
};

class PastDueReportFilters extends React.Component {
  static initialState = {
    start: moment().startOf('month').subtract(1, 'years'),
    end: moment(),
    branch: -1,
    poolType: -1,
  };

  constructor(props) {
    super(props);

    let {formatMessage} = this.props;
    const _filterOptions = Object.assign({}, filterOptions);
    const branchesFilterable = this.props.branches.map(b => {
      return {
        value: b.id,
        label: b.name,
      };
    });

    _filterOptions.branchOptions = [
      {
        value: -1,
        label: formatMessage('general.all.stores'),
      }, ...branchesFilterable];

    _filterOptions.poolTypeOptions =  [
      {
        value: -1,
        label: formatMessage('general.all.systems'),
      },
      {
        value: 1,
        label: formatMessage('general.pools'),
      },
      {
        value: 2,
        label: formatMessage('general.spas'),
      },
      {
        value: 3,
        label: formatMessage('general.swim.spas'),
      },
    ];

    this.state = compose(PastDueReportFilters.initialState, {..._filterOptions});
  }

  filterChange = ({key, value}) => {
    this.setState({[key]: value});
  };

  reset = () => {
    this.setState(PastDueReportFilters.initialState);
  };

  get value() {
    return this.state;
  }

  render() {
    const {start, end, branch, poolType, branchOptions, poolTypeOptions} = this.state;
    const {branches, formatMessage, ...props} = this.props;

    return <div className='select-options container' {...props}>
      <Row>
        <Col sm={3}>
          <LayoutDatePicker onChange={this.filterChange}
                            dataKey='start'
                            value={start}
                            maxDate={end.clone().subtract(1, 'day')}
                            dateFormat={reportDateFormat}
                            editMode={true}
                            label={formatMessage('general.date.from')} />
        </Col>
        <Col sm={3}>
          <LayoutDatePicker onChange={this.filterChange}
                            dataKey='end'
                            label={formatMessage('general.date.to')}
                            dateFormat={reportDateFormat}
                            editMode={true}
                            value={end}
                            minDate={moment(start).clone()}
                            maxDate={moment()} />
        </Col>
      </Row>
      <Row>
        <Col sm={3}>
          <ReportDropDown value={branch}
                          label={formatMessage('general.store')}
                          onChange={e => this.setState({branch: parseInt(e.target.value)})}
                          options={branchOptions} />
        </Col>
        <Col sm={3}>
          <ReportDropDown value={poolType}
                          label={formatMessage('general.system.type')}
                          onChange={e => this.setState({poolType: parseInt(e.target.value)})}
                          options={poolTypeOptions} />
        </Col>
      </Row>
    </div>;
  }
}

export default PastDueReportFilters;
